import BaseService from "./baseService";
import { reloadStores } from "../redux/actions/index";

export class StoreService extends BaseService {
  constructor(base) {
    super(base);
    this.url = "/stores";
    this.name = "Stores";
    //this.BASE_URL = "http://localhost:3000";
  }
  MatchName(id) {
    let answer = this.searchId(this.store.getState().stores, id);
    return answer ? answer.name : "-";
  }
  Search(id) {
    let answer = this.searchId(this.store.getState().stores, id);
    return answer || {};
  }
  getFullStore(id) {
    let filter = {
      //include: [{ brand: "channel" }, { zone: "channel" }]
      include: ["brand", "zone"]
    };
    return this.get(this.getIdUrl(id, filter));
  }
  getFiles(id){
    return this.get(this.url + '/playlist/' + id);
  }

  getSongs(id){
    let data = { id: id, timezone: new Date().getTimezoneOffset() };
    return this.post(this.url + '/songList/channel', JSON.stringify(data));
  }

  async getSongsFromPlaylistId(id){
    let data = { id: id, timezone: new Date().getTimezoneOffset() };
    return await this.post(this.url + '/songList/playlist', JSON.stringify(data));
  }

  reload() {
    let self = this;
    return this.read().then(function(data) {
      if (!data.hasOwnProperty("error")) {
        self.store.dispatch(reloadStores(data));
      }
    });
  }
}

export default StoreService;
